<template>
<div class="levels">

  <div class="heading-common is-btn-back">
    <a class="btn-back" @click="goBack">
    <div class="arrow-back"></div>
    </a> 
    <p class="name" style="vertical-align: middle;">{{ $t('level.title') }}</p>
  </div> 

  <div class="levels-box">
      <div class="levels-list">

        <a @click.prevent="selectLevel('N1')" class="level-link n1" disabled>
          <div class="level">
            N1
          </div>
          <div class="text">
            <p v-html="$t('level.n1_detail')"></p>
          </div>
        </a>

       <a @click.prevent="selectLevel('N2')" class="level-link n2">
          <div class="level">
            N2
          </div>
          <div class="text">
            <p v-html="$t('level.n2_detail')"></p>
          </div>
        </a>

        <a @click.prevent="selectLevel('N3')" class="level-link n3">
          <div class="level">
            N3
          </div>
          <div class="text">
            <p v-html="$t('level.n3_detail')"></p>
          </div>
        </a>

        <a @click.prevent="selectLevel('N4')" class="level-link n4-5">
          <div class="level">
            <div class="n4">N4</div>
            <div class="n5">N5</div>
            <div class="slash"></div>
          </div>
          <div class="text">
            <p v-html="$t('level.n4_detail')"></p>
          </div>
        </a>

      </div> 
  </div>
</div>
</template>

<script>
  import {appName, api, countrieList} from "../../config";
  import {mapState} from 'vuex';
  import {mapGetters} from 'vuex';

  export default {
    name: 'Levels',
    data () {
      return {
        user: null,
        profile: null,
        country: '',
        learning_total: null,
        countries: countrieList,
        subscribed: false,
        cancelStatus: false,
        subscription: {},
        subscription_plan: '',
        subscription_status: 'none'
      }
    },

  
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ]),
      isLoggedIn() {
        const authUser = this.$store.getters.getAuthUser;
        if(authUser) {
          return true;
        } else {
          return false;
        }
      },
      n1Link() {
        return '#'
      },
      n2Link() {
        return '/apps/top/n2'
      },
      n3Link() {
        return '/apps/top/n3'
      },
      n4Link() {
        return '/apps/top/n4'
      }
    },

    created() {
      let self = this
      
      self.user = null;
      self.profile = null;
      self.learning_total = null;
      
      const authUser = this.$store.getters.getAuthUser;
      if(authUser) {
        self.user = authUser;
        self.profile = { displayname: authUser.displayname, country: authUser.country, language: authUser.language };
        
        self.user.displayname = self.profile.displayname;
        self.user.country = self.profile.country;
        self.user.language = self.profile.language;
        
        self.country = this.countries.find((countryData) => {
            return (self.profile.country && countryData.val.toLowerCase() ==  self.profile.country.toLowerCase())
        })
        
        if(authUser.subscribed) {
          this.subscribed = true;
          this.cancelStatus = false;
          
          // planや状態をセット
          if(authUser.subscription !== undefined) {
            
            this.subscription = authUser.subscription
            // plan
            if(this.subscription.plan_month) {
              this.subscription_plan = 'Monthly';
            } else if(this.subscription.plan_sixmonth) {
              this.subscription_plan = '6 Months';
            } else if(this.subscription.plan_year) {
              this.subscription_plan = 'Yearly';
            }
            
            if(this.subscription.ended || this.subscription.cancelled) {
              this.cancelStatus = true;
              if(this.subscription.cancelled) {
                this.subscription_status = 'Cancelled';
              } else {
                this.subscription_status = 'Invalid';
              }
            } else if(this.subscription.gracePeriod) {
              this.subscription_status = 'Withdraw';
            } else {
              // trial中か利用中(recurring)
              if(this.subscription.trial || this.subscription.recurring) {
                this.cancelStatus = false;
                
                if(this.subscription.trial) {
                  this.subscription_status = 'Trial';
                } else {
                  this.subscription_status = 'Active';
                }
              }
            }
          }
        }
      }

      axios.get(api.learningLog)
        .then((resp) => {
          self.$store.dispatch('setLearningTotal',  resp.data)
          
          self.learning_total = self.$store.getters.learning_total
        })
        .catch(err => {
          (err.response && err.response.data.error)
            ? self.setErrors(err.response.data.error)
            : self.clearErrors();
        });
        
    },

    methods: {
      selectLevel(level) {
        if(level == "N2" ||level == "N3" || level == "N4") {
          this.$store.dispatch('setUseLevel', level);
          
          window.location.href = '/apps/top/' + level.toLowerCase();
        }
      },
      goBack() {
        const currentSection = this.$store.getters.section_data
        if(currentSection && currentSection.level) {
          this.$router.push({ name: 'top.level', params: { level: currentSection.level.toLowerCase() } });
        } else {
          this.$router.push({ name: 'top' });
        }
      },
      //TODO: 取得できなかった場合のエラー
      setErrors(errors) {
        this.$store.dispatch('showLoading', false);
        this.error.profile = errors.profile ? errors.profile[0] : null;
      },
      clearErrors() {
        this.$store.dispatch('showLoading', false);
        this.error.profile = null;
      }
    },
  }
</script>